export type Primitive = string | number | boolean | null | undefined | symbol | bigint;
export type PrimitiveRecord = Record<string, Primitive>;

export function flattenObject(item: Record<string, unknown>, prefix: string = ""): PrimitiveRecord {
  const result: PrimitiveRecord = {};
  const base = prefix ? prefix + "." : "";

  if (Array.isArray(item)) {
    item.forEach((value, index) => {
      const key = base + index;

      if (value !== null && typeof value === "object") {
        Object.assign(result, flattenObject(value as Record<string, unknown>, key));
      } else {
        result[key] = value as Primitive;
      }
    });
  } else {
    for (const [key, value] of Object.entries(item)) {
      if (value !== null && typeof value === "object") {
        Object.assign(result, flattenObject(value as Record<string, unknown>, base + key));
      } else {
        result[base + key] = value as Primitive;
      }
    }
  }

  return result;
}
